import { useMutation } from '@tanstack/react-query';
import type { BulkChangeOrganizationUserRequest } from '../types/CandidateProfile';

export default function useBulkChangeOrganizationUser() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkChangeOrganizationUserRequest) => {
      const response = await fetch('/agent/api/candidate_profiles/bulk_change_organization_user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || '担当者の変更に失敗しました');
      return data;
    },
  });
}
